<template>
  <div>
    <img
      class="titleimg"
      src="/static/imgs/shouye6.png"
      style="width: 100%; height: 150px ;object-fit: cover;"
    />
    <div class="box">
      <div class="left hidden-xs-only">
        <p class="PRODUCT">SOFTWARE</p>
        <p>软件平台</p>
        <div class="list">
          <div class="item">
            <ul>
              <p>管理系统</p>
              <li @click="to_info('Ljiankong')">综合指挥调度系统</li>
              <li @click="to_info('Sjiankong')">收费系统运行监测报警系统</li>
              <li @click="to_info('jidian')">收费数据统计分析系统</li>
           
            </ul>
          </div>
          <div class="item">
            <ul>
              <p>移动终端</p>
              <li @click="to_info('yidong')">移动终端App/小程序应用软件</li>
            </ul>
          </div>
          <!-- <div class="item">
            <ul>
              <p>在线监控平台</p>
              <li @click="to_info('jidian')">高速公路机电实时监控报警平台</li>
              <li @click="to_info('yidong')">移动终端App路段监控应用软件</li>
            </ul>
          </div>
          <div class="item">
            <ul>
              <p>机电设备养护平台</p>
              <li @click="to_info('yanghu')">智能养护平台软件</li>
            </ul>
          </div>
          <div class="item">
            <ul>
              <p>分析与稽查平台</p>
              <li @click="to_info('jicha')">路段车辆车流稽查统计分析</li>
            </ul>
          </div> -->
        </div>
      </div>
      <div class="right">
        <div class="tunnel">
          <p class="title">管理系统</p>
          <div class="flex" style="display: flex; justify-content: space-between;height: 400px;">
            <!-- <div class="itme_li" @click="to_info('Sjiankong')">
              <img src="/static/imgs/index.png" alt="" />
              <p class="minTilte">隧道监控及应急指挥调度平台软件</p>
              <p>
                隧道监控及应急指挥调度平台软件是为有效应对隧道可能出现的突发事件而研制出的一种隧道应急系统。应急指挥调度软件可以根据事件发生地点、性质、严重程度、所需要的社会救援单位等不同情况，为相关人员提供针对不同事件的应急程序
              </p>
            </div> -->
            <div class="itme_li" @click="to_info('Ljiankong')">
              <img src="/static/imgs/luduanjiankong.png" alt="" />
              <p class="minTilte">综合指挥调度系统</p>
              <p>
                易通达综合指挥调度系统实现对道路交通运行状态及道路环境情况的实时监控，对突发事件进行统一协调、统一管理，具有对路段/路网进行全面监控、应急处理、指挥调度、交通透导等功能。
              </p>
            </div>
            <div class="itme_li" @click="to_info('Sjiankong')">
              <img src="/static/imgs/shoufeixitong.png" alt="" />
              <p class="minTilte">收费系统运行监测报警系统</p>
              <p>
                收费系统运行监测报警系统是针对专用机电设备、计算机、服务器、网络环境以及应用软件的健康情况进行实时检测，对异常情况即时报警，从而保障数据正常和业务的连续性，做到防范于未然，以降低系统的运营风险，提高管理效率。
              </p>
            </div>
      
          </div>
          <div class="flex" style="display: flex; justify-content: space-between;height: 400px;" >
            <div class="itme_li" @click="to_info('jidian')">
              <img src="/static/imgs/shoufeishuju.png" alt="" />
              <p class="minTilte">收费数据统计分析系统</p>
              <p>
                收费数据统计分析系统使用门架交易数据、门架牌识数据、车道交易数据，对数据进行深度挖掘分析，形成流量、拆分、OD、可疑车辆等统计分析数据，有效提升路段管理能力和稽核能力。
              </p>
            </div>
 
          </div>
        </div>
        <div class="monitoring">
          <p class="title">移动终端</p>
          <div  class="flex" style="display: flex; justify-content: space-between">
            <div class="itme_li" @click="to_info('yidong')">
              <img src="/static/imgs/iphone.png" alt="" />
              <p class="minTilte">移动终端App/小程序应用软件</p>
              <p>
                移动互联是信息和决策传递中及时性、准确性的重要保证手段，我司针对不同系统移动终端使用的APP做了重点开发，通过移动互联完成各系统综合信息监控以及应急指挥调度。
              </p>
            </div>
          </div>
          </div>
        <!-- <div class="monitoring">
          <p class="title">在线监控平台软件</p>
          <div style="display: flex; justify-content: space-between">
            <div class="itme_li" @click="to_info('jidian')">
              <img src="/static/imgs/gaosugonglu.png" alt="" />
              <p class="minTilte">高速公路机电实时监控报警平台</p>
              <p>
                高速公路机电系统运行监测报警综合平台是针对专用机电设备、计算机、服务器、网络环境以及应用软件的健康情况进行实时检测，对异常情况即时报警，从而保障数据正常和业务的连续性，做到防范于未然，以降低系统的运营风险，提高管理效率
              </p>
            </div>
            <div class="itme_li" @click="to_info('yidong')">
              <img src="/static/imgs/iphone.png" alt="" />
              <p class="minTilte">移动终端App路段监控应用软件</p>
              <p>
                移动互联是信息和决策传递中及时性、准确性的重要保证手段，因此，路段监控平台系统还针对移动终端使用的APP做了重点开发，通过移动互联完成隧道/路段综合信息监控以及应急指挥调度
              </p>
            </div>
          </div>
        </div>
        <div class="electromechanical">
          <p class="title">机电设备养护平台软件</p>
          <div style="display: flex; justify-content: space-between">
            <div class="itme_li" @click="to_info('yanghu')">
              <img src="/static/imgs/jidianyanghu.png" alt="" />
              <p class="minTilte">智能养护平台软件</p>
              <p>
                易通达高速公路智能养护平台就是针对高速公路常态化运营下，机电设备的维护保养、巡检巡查等问题专门开发的智能系统平台。实时检测收费岛面设备、路段监控设备及机房设备工作状态
              </p>
            </div>
          </div>
        </div>
        <div class="inspect">
          <p class="title">分析与稽查平台</p>
          <div style="display: flex; justify-content: space-between">
            <div class="itme_li" @click="to_info('jicha')">
              <img src="/static/imgs/jicha.png" alt="" />
              <p class="minTilte">路段车辆车流稽查统计分析</p>
              <p>
                利用门架数据（交易，牌识）和收费数据，对车流进行分析，形成管理相关报表，同时实现可疑车辆的筛查。
              </p>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  components: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {
    this.elevator();
    this.$root.$on("change", (val) => {
      this.elevator(val);
    });
  },
  watch: {},
  methods: {
    to_info(item){
      // console.log(item);
      this.$router.push({
        path:'/home/software_info',
        query:{
          item:item
        }
      })
      // console.log(item);
    },
    // elevator(val) {
    //   if (val == 0) {
    //     let a = document.querySelector(".tunnel").offsetTop;
    //     document.documentElement.scrollTop = a;
    //   }
    //   let index = val ? val : this.$route.query.index;
    //   if (index == -1) {
    //     document.documentElement.scrollTop = 0;
    //   } else if (index == 0) {
    //     let a = document.querySelector(".tunnel").offsetTop;
    //     document.documentElement.scrollTop = a;
    //   } else if (index == 1) {
    
    //     let a = document.querySelector(".monitoring").offsetTop;
    //     document.documentElement.scrollTop = a;
    //     // console.log(a);
    //   } else if (index == 2) {
    //     let a = document.querySelector(".electromechanical").offsetTop;
    //     document.documentElement.scrollTop = a;
    //   } else if (index == 3) {
    //     let a = document.querySelector(".inspect").offsetTop;
    //     document.documentElement.scrollTop = a;
    //   }
    // },
    elevator(val) {
      let a =null
      if (val == 0) {
         a = document.querySelector(".tunnel").offsetTop;
        // document.documentElement.scrollTop = a;
      }
      let  index = val ? val : this.$route.query.index;
      if (index == -1) {
        a = 0
        // document.documentElement.scrollTop = 0;
      } else if (index == 0) {
         a = document.querySelector(".tunnel").offsetTop;
        // document.documentElement.scrollTop = a;
      } else if (index == 1) {
    
         a = document.querySelector(".monitoring").offsetTop;
        // document.documentElement.scrollTop = a;
        // console.log(a);
      } else if (index == 2) {
         a = document.querySelector(".electromechanical").offsetTop;
        // document.documentElement.scrollTop = a;
      } else if (index == 3) {
         a = document.querySelector(".inspect").offsetTop;
        // document.documentElement.scrollTop = a;
      }
      this.$nextTick(()=>{
        document.documentElement.scrollTop = a;
      
      })
    },
  },

  beforeDestroy() {},
};
</script>

<style scoped lang="less">
@media screen and(max-width:700px){
::v-deep .box{
  width: 100% !important;
  margin-bottom: 100px;
  height: auto;
}
.flex{
  display: block !important;
  height: auto !important;
 
  .itme_li{
    margin: 0 auto;
  }
}
.titleimg{
  height: auto !important;
}

}
.box {
  margin: 0 auto;
  margin-top: 16px;
  width: 1400px;
  height: 100%;
  //   background-color: pink;
  //   overflow: hidden;
  display: flex;
  .left {
    width: 200px;
    margin-right: 20px;
    border-right: 1px solid #1555d01a;
    .list {
      margin-top: 30px;
      overflow: hidden;
      .item {
        margin-top: 10px;
        p {
          text-align: left;
          font-weight: 700;
    font-size: 20px;
   
        }
        ul {
      
          li {
            text-align: left;
            font-size: 14px;
            list-style: none;
            height: 30px;
            line-height: 30px;
            cursor: pointer;
            text-overflow: ellipsis;
            overflow: hidden;
            width: 100%;
            text-overflow: ellipsis;
            overflow: hidden;
            width: 100%;
            word-break: keep-all;
          }
          li:hover {
            color: #0035ffff;
          }
        }
      }
    }
    .PRODUCT {
      color: #1555d0ff;
      font-size: 24px;
      font-weight: 700;
      font-family: "MiSans-B";
      text-align: left;
      margin-bottom: 16px;
      margin-top: 70px;
    }
    p {
      color: #000000ff;
      font-size: 32px;
      font-weight: 700;
      font-family: "MiSans-B";
      text-align: left;
    }
  }
  .right {
    flex: 1;
    margin-left: 30px;
    .tunnel {
      margin-top: 70px;
      .title {
        font-size: 32px;
        font-weight: 600;
        font-family: "MiSans-B";
        margin-bottom: 24px;
      }
      .itme_li {
        width: 536px;
        height: 380px;
        transition: all 0.5s;
        cursor: pointer;
        overflow: hidden;
        img {
          width: 100%;
          height: 254px;
          transition: all 0.5s;
          overflow: hidden;
        }
        img:hover{
          transform: scale(1.05);
        }
        .minTilte {
          font-size: 24px;
          font-weight: 600;
          font-family: "MiSans";
          text-align: left;
          text-indent: 0;
          padding: 0 16px;
          margin: 8px 0;
        }
        p {
          font-size: 14px;
          font-weight: 400;
          font-family: "MiSans";
          text-align: left;
          text-indent: 2em;
          padding: 0 16px;
        }
      }
      .itme_li:hover {
        box-shadow: -8px 7px 20px 6px #0000001a;
        border-bottom: 5px solid #1555d0;
        img{
          transform: scale(1.05);
        }
      }
    }
    .monitoring {
      height: 500px;
      .title {
        font-size: 32px;
        font-weight: 600;
        font-family: "MiSans-B";
        margin-bottom: 24px;
      }
      .itme_li {
        cursor: pointer;
        width: 536px;
        height: 380px;
        transition: all 0.5s;
        overflow: hidden;
        img {
          width: 100%;
          height: 254px;
          transition: all 0.5S;
        }

        .minTilte {
          font-size: 24px;
          font-weight: 600;
          font-family: "MiSans";
          text-align: left;
          text-indent: 0;
          padding: 0 16px;
          margin: 8px 0;
        }
        p {
          font-size: 14px;
          font-weight: 400;
          font-family: "MiSans";
          text-align: left;
          text-indent: 2em;
          padding: 0 16px;
        }
      }
      .itme_li:hover {
        box-shadow: -8px 7px 20px 6px #0000001a;
        border-bottom: 5px solid #1555d0;
        img {
        transform: scale(1.05);
      }
      }
    }
    .electromechanical {
      height: 500px;
      .title {
        font-size: 32px;
        font-weight: 600;
        font-family: "MiSans-B";
        margin-bottom: 24px;
      }
      .itme_li {
        cursor: pointer;
        width: 536px;
        height: 380px;
        transition: all 0.5s;
        overflow: hidden;
        img {
          width: 100%;
          height: 254px;
          transition: all 0.5S;
        }

        .minTilte {
          font-size: 24px;
          font-weight: 600;
          font-family: "MiSans";
          text-align: left;
          text-indent: 0;
          padding: 0 16px;
          margin: 8px 0;
        }
        p {
          font-size: 14px;
          font-weight: 400;
          font-family: "MiSans";
          text-align: left;
          text-indent: 2em;
          padding: 0 16px;
        }
      }
      .itme_li:hover {
        box-shadow: -8px 7px 20px 6px #0000001a;
        border-bottom: 5px solid #1555d0;
        img {
        transform: scale(1.05);
      }

      }
    }
    .inspect {
      height: 500px;
      .title {
        font-size: 32px;
        font-weight: 600;
        font-family: "MiSans-B";
        margin-bottom: 24px;
      }
      .itme_li {
        cursor: pointer;
        width: 536px;
        height: 380px;
        transition: all 0.5s;
        overflow: hidden;
        img {
          width: 100%;
          height: 254px;
          transition: all 0.5S;
        }
 
        .minTilte {
          font-size: 24px;
          font-weight: 600;
          font-family: "MiSans";
          text-align: left;
          text-indent: 0;
          padding: 0 16px;
          margin: 8px 0;
        }
        p {
          font-size: 14px;
          font-weight: 400;
          font-family: "MiSans";
          text-align: left;
          text-indent: 2em;
          padding: 0 16px;
        }
      }
      .itme_li:hover {
        box-shadow: -8px 7px 20px 6px #0000001a;
        border-bottom: 5px solid #1555d0;
        img {
        transform: scale(1.05);
      }
      }
    }
  }
}
</style>
